export const customParametersStyle = (components, theme) => ({
  '& .flex-row-dynamic': {
    verticalAlign: 'initial',
  },

  '& .custom-param-entry': {
    '& .control-label': {
      display: 'inline-block',
    },
    '& input.form-control': {
      display: 'inline-block',
    },
    '& label.control-label': {
      display: 'inline-block',
      marginLeft: '5px',
      marginRight: '5px',
    },
    '& .custom-param__key-field': {
      width: '155px',
      display: 'inline-block',
    },
    '& .custom-param__value-field': {
      width: '260px',
      display: 'inline-block',
    },
  },

  // private\ui-next\packages\top-grid-panel\src\upgraded-url-override-style.js
  '& .custom-params-template .custom-param-entry': {
    display: 'flex',
    alignItems: 'center',
  },
  '& .custom-params-template .custom-param-entry td': {
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .custom-params-template .flex-row-fixed.custom-param__key-container': {
    display: 'flex',
    alignItems: 'baseline',
  },
  '& .custom-params-template .flex-row-fixed.custom-param__key-container .control-label': {
    display: 'inline',
    marginLeft: 5,
    marginRight: 5,
    whiteSpace: 'pre',
    width: 'unset',
  },
  '& .custom-params-template .flex-row-fixed.custom-param__key-container input.form-control.custom-param__key-field': {
    margin: '0px 5px',
    display: 'inline',
    width: 85,
  },
  '& .custom-params-template .flex-row-dynamic input.form-control.custom-param__value-field': {
    marginLeft: '5px',
    width: 150,
    display: 'inline',
  },
  '& .custom-params-template .closeimage.custom-param__close-button': {
    cursor: 'pointer',
    display: 'flex',
    height: 20,
    marginLeft: 10,
    padding: 0,
    position: 'static',
    alignItems: 'center',

    '&:before': {
      fontFamily: theme.iconFontFamily,
      content: '"\\E711"',
    },
  },
});
